import { render, staticRenderFns } from "./SelectRegion.vue?vue&type=template&id=84dda39e&scoped=true&"
import script from "./SelectRegion.vue?vue&type=script&lang=js&"
export * from "./SelectRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84dda39e",
  null
  
)

export default component.exports